module.exports = __webpack_public_path__ + "static/media/ksd.header.logo.160w.fc59f45a.png";